import { OrganType } from "@nkr/enums/organ-type";
import { IBaseResponse } from "@nkr/models/base-response";
import { ISelectItem } from "@nkr/models/select-item";
import { IObjectResponse, IArrayResponse } from "@nkr/store/application";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { IApplicationState } from "@nkr/store/index";
import moment from "moment";
import { Dispatch } from "react-redux";

export interface IManualInvoiceLineItem {
    id: number,
    userId: number,
    username: string,
    centerId: number,
    centerAlias: string,
    organType: OrganType,
    date: string,
    description: string,
    applyTo: number,
    applyToDescription: string,
    isCredit: boolean,
    amount: number
}

export interface IManualInvoiceLineItemLookup {
    centers: ISelectItem[],
    invoiceLineItemTypes: ISelectItem[],
}

export const ActionsAdminLineItems = {

    getLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<IObjectResponse<IManualInvoiceLineItemLookup>> => {
        var options = {
            url: `${__API__}/billing/manual-line-item/lookup`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IObjectResponse<IManualInvoiceLineItemLookup>) => {
            return Promise.resolve(response);
        });
    },

    getLineItems: (invoiceDate: string, organType?: OrganType) => (dispatch: Dispatch<IApplicationState>): Promise<IArrayResponse<IManualInvoiceLineItem>> => {
        var options = {
            url: `${__API__}/billing/manual-line-item/${invoiceDate}?organType=${organType}`
        };
        return dispatch(AuthActionCreators.apiGet(options)).then((response: IArrayResponse<IManualInvoiceLineItem>) => {
            return Promise.resolve(response);
        });
    },

    addLineItem: (lineItem: IManualInvoiceLineItem) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/billing/manual-line-item`,
            data: lineItem
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    removeLineItem: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/billing/manual-line-item/${id}`
        };

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    }

};